import packageJson from "../../package.json";

export const ENVIRONMENT: "prod" | "dev" | "dev-local" = import.meta.env
    .VITE_ENVIRONMENT;
export const CONFIG_MANIFEST_URL: string = import.meta.env.VITE_MANIFEST;

const title =
    ENVIRONMENT === "prod"
        ? "Trade Master"
        : `${ENVIRONMENT.toUpperCase()} Trade Master`;

export const APP_VERSION = packageJson.version;
export const APP_VERSION_PERSIST = packageJson["persist-version"];
export const APP_VERSION_CONFIG = 384;

export const KPI_DELAY_DAYS = Number(import.meta.env.VITE_KPI_DELAY_DAYS || 0);

export const DISABLE_PWA_TRIGGER = ENVIRONMENT !== "prod";

export const MERCURE_HUB_URL =
    "https://mercure.trademaster.in.ua/.well-known/mercure";

const loader = {
    delay: 300,
    minimumLoading: 700,
};

const defaultMetaTags = {
    image: "/pwa-512x512.png",
    description: "React app",
};

export { defaultMetaTags, loader, title };

export const reminderDelayTimeType = "hour";
export const reminderDelayValue = 1;

export const TASK_SCREEN_RECORDING_USER_IDS = [
    "019ac533-5733-7bf6-b5ea-0f432a54a2b0",
    "019ac531-17c9-767c-acb3-7144425bb040",
    "019ac530-c93a-756b-b45c-4b7fd6d23602",
];
